<template>
  <draggable
    class="dragArea list-group"
    tag="ul"
    :list="children"
    group="critere"
    :added="elementAdded"
    v-bind="dragOptions"
    @start="isDragging = true"
    @end="isDragging = false"
    @change=emitCleanRequeteNode
  >
    <li class="list-group-item" :class="{dragcontainer: el.children.length > 0 }" v-for="el in children" :key="el.id">
      <span class="operator" @click="emitChangeLineOperator(el)">{{translateOperator(el.chOps)}}</span>
      <input-comp
        v-if="el.chTypes"
        :inputelement="el"
        @deleteCritere="deleteFormCritere($event)">
      </input-comp>
      <nested-drag-req :children="el.children "/>
    </li>

  </draggable>

</template>
<script>
import draggable from 'vuedraggable'
import { mapActions, mapGetters } from 'vuex'

import InputComp from './InputComp'

export default {
  props: {
    children: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      translateOps: { 'AND': 'ET', 'OR': 'OU', 'NOT': 'SAUF' }
    }
  },
  mounted () {
    this.$store.dispatch('emitCleanRequeteNode')
  },
  components: {
    InputComp,
    draggable
  },
  name: 'nested-drag-req',
  computed: {
    dragOptions () {
      return {
        animation: 0,
        group: 'description',
        disabled: false,
        ghostClass: 'fromghost'
      }
    },
    valueString () {
      return JSON.stringify(this.list2, null, 2)
    }
  },
  methods: {
    ...mapActions([
      'emitChangeLineOperator',
      'emitCleanRequeteNode'
    ]),
    elementAdded: function (evt) {
      console.log('elementAdded')
    },
    log: function (evt) {
      window.console.log(evt)
    },
    translateOperator (obj) {
      return this.translateOps[obj]
    },
    addToForm ({ title, type }) {
      return {
        id: idGlobal++,
        title: title,
        children: false,
        parent: null,
        type: type
      }
    },
    returnLevel (id) {
      return 'level_' + id
    },
    toggleSousCritere (element) {
      element.open = !element.open

      this.list1.filter(function (item) {
        if (item.parent && (item.parent == element.id)) {
          item.show = !item.show
        }
      })
    },
    deleteFormCritere (element) {
      // @todo : delete from Services
      console.log('delete node N' + element.id)
      this.children.splice(this.children.findIndex(e => e.id === element.id), 1)
      this.emitCleanRequeteNode(element)
    },
    updateChOps (element) {
      console.log('Update Ops')
    }
  }
}
</script>
<style lang="scss" scoped>

  ul {
    padding-left: 0;
  }

  li {
    list-style: none;
  }

  .form-list-wrap .list-group {
    padding-left: 0;
  }

  .form-list-wrap .list-group li {

  }

  ul {
    padding-left: 0;
  }

  li {
    list-style: none;
  }

  .form-list-wrap ul.list-group {

    li.dragcontainer ul li.dragcontainer {
      background-color: #d0d0d0;
      margin: 0 0 -1px 10px;
      /*background-color: blue;*/
    }

    li.dragcontainer:first-child {
      border-top: 1px solid rgba(0, 0, 0, .125);
    }

    li.dragcontainer {
      background-color: #e0e0e0;
      padding: 20px 10px 30px 10px;

      box-shadow: none;

      .operator {
        /* background-color: red;*/
      }

      ul li .operator {

        /*background-color: green;*/
      }

    }

    li {
      padding: 5px 15px;
      margin: 5px 0 -1px 0;
      border-radius: 2px;
      box-shadow: 0 1px 2px rgba(0, 0, 0, .3);

      .operator {
        background-color: #626D7E;
        color: white;
        border-radius: 0 20px 20px 0;
        height: 30px;
        width: 50px;
        display: block;
        line-height: 30px;
        left: -1px;
        top: -18px;
        font-size: 10px;
        text-align: center;
        position: absolute;
        box-shadow: 1px 0 6px rgba(0, 0, 0, .5);
        z-index: 99;
      }

      .fromghost .operator {
        display: none;
      }

      ul li {
        padding: 5px 15px;
        margin: 5px 0 -1px 0;
        border-radius: 2px;

        .operator {

        }

        .fromghost .operator {
          display: none;
        }
      }

      ul li ul li {
        padding: 5px 60px;
        margin: 5px 0 -1px 10px;
        border-radius: 2px;

        .operator {
        }

        .fromghost .operator {
          display: none;
        }
      }

    }

    li:first-child > .operator {
      display: none;
    }

  }

</style>
